import { tien, tienGon } from './api';
import { useHoiLai } from './hoi-lai';
import type { ThanhTich } from './kieu';

/**
 * Thành tích hôm nay của CHÍNH người đang đăng nhập, nhét vào giữa thanh trên.
 *
 * Dùng ở màn tư vấn — màn chạy trên ĐIỆN THOẠI, nên đây là chỗ chật nhất trong
 * cả ba giao diện.
 *
 * 🔴 MỘT DÒNG, và chiều cao phải NHỎ HƠN khối tên người bên phải.
 *
 *    Thanh trên dùng chung cho cả ba màn; chiều cao của nó do đứa con cao nhất
 *    quyết định. Nhét vào đây một khối hai dòng là đẩy thanh trên cao thêm trên
 *    CẢ ba màn, để lấy chỗ cho một con số chỉ màn tư vấn cần.
 *
 * 🔴 KHÔNG cắt bớt số tiền.
 *
 *    Ở bề ngang ~390px chỗ này chỉ còn khoảng 60–90px. Cắt chữ thì phần bị cắt
 *    là đuôi — tức là hàng nghìn của số tiền, và "2.420.878 ₫" cụt thành
 *    "2.420…" thì đọc ra một con số KHÁC hẳn chứ không phải một con số thiếu.
 *
 *    Nên: cả cụm `white-space: nowrap` và `flex-shrink: 0`, chấp nhận đẩy hẹp
 *    khối tên người (nó đã có `text-overflow: ellipsis`, cắt tên thì vô hại).
 *    Cùng nguyên tắc đã dùng ở dòng hàng đợi thu ngân: cắt tên người trước, số
 *    tiền không bao giờ co.
 *
 * Nhịp 30 giây: đây là con số động viên, không ai đứng chờ nó nhích.
 */
export function ThanhTichNho() {
  const { duLieu } = useHoiLai<ThanhTich>('/api/bao-cao/thanh-tich', 30_000);

  if (!duLieu) {
    // Khung xương đúng bằng chỗ chữ sẽ chiếm, để thanh trên không giật một nhịp
    // lúc số về.
    return (
      <div className="xuong" style={{ width: 108, height: 30, borderRadius: 'var(--tron)' }} />
    );
  }

  const { so_mon, doanh_so } = duLieu.cua_toi;

  return (
    /*
      Giếng LÕM, cùng kiểu với khối tên người bên phải.

      🔴 Lõm vì đây là thứ để ĐỌC, không phải thứ bấm được. Ở phong cách này, nổi
         lên = đụng vào được, lõm xuống = một con số khắc lên mặt bàn. Cho nó nổi
         thì ngón tay sẽ thử bấm.

      🔴 Đệm ngang 10px, KHÔNG phải 16px như khối tên.
         Chỗ giữa thanh trên ở màn 390px chỉ còn ~88px; mỗi 2px đệm là 4px mất đi
         của phần chứa số. Đã đo: 10px là mức vừa đủ để cái giếng đọc ra là giếng
         mà chữ vẫn không bị cắt ở cả 390px lẫn 360px.
    */
    <div
      className="lom-nho hien-mo o-thanh-tich"
      style={{
        display: 'flex',
        alignItems: 'baseline',
        gap: 6,
        whiteSpace: 'nowrap',
        flexShrink: 0,
        lineHeight: 1.2,
        padding: '7px 10px',
        borderRadius: 'var(--tron)',
      }}
      title={`Hôm nay: ${so_mon} món · ${tien(doanh_so)}`}
    >
      <span className="so an-khi-rat-hep" style={{ fontSize: 12, fontWeight: 700 }}>
        {so_mon}
      </span>
      <span className="an-khi-hep" style={{ fontSize: 10, color: 'var(--chu-3)' }}>
        món
      </span>
      <span className="an-khi-rat-hep" style={{ fontSize: 10, color: 'var(--chu-3)' }}>
        ·
      </span>
      {/* Số RÚT GỌN, không phải số cắt cụt — xem chú thích của `tienGon`.
          Số đầy đủ nằm trong `title` của cả dải. */}
      <span className="tien" style={{ fontSize: 12, fontWeight: 700, marginLeft: 2 }}>
        {tienGon(doanh_so)}
      </span>
    </div>
  );
}
